import { Checkbox, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { useMemo, useRef, useState } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import FormatsRow from './FormatsRow';

const ROW_HEIGHT = 54;

const FormatsTablePreview = ({ articles, newFormats, editedFormats, withOutChangesFormats, withIssuesFormats }) => {
  const parentRef = useRef(null);

  const [articleExcelTypeFilter, setArticleExcelTypeFilter] = useState(['created', 'edited', 'with-issues']);

  const filteredFormats = useMemo(() => {
    let filteredArticles = [];

    if (articleExcelTypeFilter.length > 0) {
      if (articleExcelTypeFilter.includes('with-issues')) {
        filteredArticles = [...filteredArticles, ...withIssuesFormats];
      }
      if (articleExcelTypeFilter.includes('created')) {
        filteredArticles = [...filteredArticles, ...newFormats];
      }
      if (articleExcelTypeFilter.includes('edited')) {
        filteredArticles = [...filteredArticles, ...editedFormats];
      }
      if (articleExcelTypeFilter.includes('with-out-changes')) {
        filteredArticles = [...filteredArticles, ...withOutChangesFormats];
      }
    }

    return filteredArticles;
  }, [newFormats, editedFormats, withOutChangesFormats, withIssuesFormats, articleExcelTypeFilter]);

  const formatMapping = useMemo(() => {
    const mapping = {};
    newFormats.forEach((format) => {
      mapping[format.code] = 'created';
    });
    editedFormats.forEach((format) => {
      mapping[format.code] = 'edited';
    });
    withOutChangesFormats.forEach((format) => {
      mapping[format.code] = 'with-out-changes';
    });
    withIssuesFormats.forEach((format) => {
      mapping[format.code] = 'with-issues';
    });
    return mapping;
  }, [newFormats, editedFormats, withOutChangesFormats, withIssuesFormats]);

  const rowVirtualizer = useVirtualizer({
    count: filteredFormats.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => ROW_HEIGHT,
    overscan: 5,
  });
  return (
    <>
      <div className="articles-table-filter-container">
        <div
          style={{
            width: '20rem',
          }}
        >
          <InputLabel size="small" id="centerType-label">
            Tipo formato
          </InputLabel>
          <br />
          <Select
            style={{
              width: '20rem',
            }}
            size="small"
            id="demo-multiple-checkbox"
            labelId="centerType-label"
            multiple
            value={articleExcelTypeFilter}
            onChange={(e) => setArticleExcelTypeFilter(e.target.value)}
            input={<OutlinedInput label="centerType-label" />}
            renderValue={(selected) => {
              const statusMapping = {
                created: 'Por Crear',
                edited: 'Por editar',
                'with-out-changes': 'Sin cambios',
                'with-issues': 'Con problemas',
              };
              return selected.map((s) => statusMapping[s]).join(', ');
            }}
          >
            <MenuItem value="created">
              <Checkbox checked={articleExcelTypeFilter.includes('created')} />
              <ListItemText primary="Por Crear" />
            </MenuItem>
            <MenuItem value="edited">
              <Checkbox checked={articleExcelTypeFilter.includes('edited')} />
              <ListItemText primary="Por editar" />
            </MenuItem>
            <MenuItem value="with-out-changes">
              <Checkbox checked={articleExcelTypeFilter.includes('with-out-changes')} />
              <ListItemText primary="Sin cambios" />
            </MenuItem>

            <MenuItem value="with-issues">
              <Checkbox checked={articleExcelTypeFilter.includes('with-issues')} />
              <ListItemText primary="Con problemas" />
            </MenuItem>
          </Select>
        </div>
      </div>
      <div className="articles-table-major-container">
        <div className="articles-table-inner">
          <table className="table-preview table-formats-preview table-header">
            <thead>
              {filteredFormats.length > 0 && (
                <tr>
                  <th>CODIGO ARTICULO</th>
                  <th>CODIGO FORMATO</th>
                  <th>FORMATO</th>
                  <th>MATERIAL</th>
                  <th>ACTIVO</th>
                  <th>PERSONALIZADO</th>
                </tr>
              )}
            </thead>
          </table>

          <div ref={parentRef} className="table-content-articles-container">
            <table className="table-preview table-formats-preview table-body">
              {filteredFormats.length > 0 ? (
                <tbody
                  style={{
                    height: `${rowVirtualizer.getTotalSize()}px`,
                    position: 'relative',
                    display: 'block',
                  }}
                >
                  {rowVirtualizer.getVirtualItems().map((virtualRow) => {
                    const row = filteredFormats[virtualRow.index];
                    if (!row) return null;

                    const article = articles.find((a) => a.code === row.codeArticle);
                    row.type = formatMapping[row.code];

                    return (
                      <FormatsRow
                        key={`${row?.code}-${virtualRow.index}`}
                        article={article}
                        format={row}
                        index={virtualRow.index}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: `${virtualRow.size}px`,
                          transform: `translateY(${virtualRow.start}px)`,
                        }}
                      />
                    );
                  })}
                </tbody>
              ) : (
                <tbody style={{ height: `10rem` }}>
                  <tr style={{ height: `10rem` }}>
                    <span
                      style={{
                        color: '#6e6b6b',
                        fontSize: '1.2rem',
                        fontStyle: 'italic',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '1rem 2rem',
                      }}
                    >
                      No hay formatos para mostrar
                    </span>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormatsTablePreview;
